import { Component, OnInit } from '@angular/core';
import { AdsPricing, AdsPricingResponse } from '../../models/inModels/Advert';
import { ConfirmationService, DataTable, LazyLoadEvent, Message, SelectItem } from 'primeng/primeng';
import { NotificationContentType } from '../../models/inModels/MessageModel';
import { AdvertOrderService } from '../../services/business/advert-order.service';
import { StorageService } from '../../services/system/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ads-pricing',
  templateUrl: './ads-pricing.component.html'
})
export class AdsPricingComponent implements OnInit {
	rows: SelectItem[];
  items: AdsPricingResponse[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
  displayModal: boolean = false;
  isEditMode: boolean = false;
  model: AdsPricing;

  constructor(private service: AdvertOrderService,
    public storageService: StorageService,
    private router: Router,
    private confirmationService: ConfirmationService) {
    this.model = new AdsPricing();
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
  }

  ngOnInit() {
  }

  edit(adsPricing: AdsPricingResponse) {
		// Open dialog on edit mode
    this.model = new AdsPricing(adsPricing);
	}

  changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

  showModalDialog(adsPricing: AdsPricingResponse = null) {
    this.model = new AdsPricing(adsPricing);
		if (adsPricing != null) this.isEditMode = true;
		else this.isEditMode = false;

		this.displayModal = true;
	}

  handleImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.ImageId = result.PublicId;
		this.loading = false;
	}
		
	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

  create() {
		this.loading = true;
    this.items.sort((a, b) => a.Id - b.Id);
    this.model.Id = this.items[this.items.length -1].Id + 1;
		this.service.createPricing(this.model).then(
			result => {
				this.loading = false;
				this.error = [];
        this.load(this.rowEvent);
				this.error.push({ severity: 'success', summary: 'Success', detail: "Created successfully" });
				this.displayModal = false;
			},
			error => {
				this.loading = false;
				this.error = [];
        this.load(this.rowEvent);
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	update() {
		this.loading = true;
    this.model.AdSpace = this.model.Name;
		this.service.updatePricing(this.model).then(
			result => {
				this.loading = false;
				this.error = [];
        this.load(this.rowEvent);
				this.error.push({ severity: 'success', summary: 'Success', detail: "Ad Space Pricing Saved" });
				this.displayModal = false;
			},
			error => {
				this.loading = false;
        this.load(this.rowEvent);
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

  goBack(): void {
		this.router.navigate(['/subscriptions/plans']);
  }

  load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.loadPricing().then(
			dataPager => {
				this.items = dataPager;
				this.loading = false;
        this.model = new AdsPricing();
			},
			error => {
        this.model = new AdsPricing();
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/ads-pricing/ads-pricing.component.ts